/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_ArchiveInputs */

const en_admin_registration_archive = /** @type {(inputs: Admin_Registration_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const de_admin_registration_archive = /** @type {(inputs: Admin_Registration_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiv`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Admin_Registration_ArchiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_archive = /** @type {((inputs?: Admin_Registration_ArchiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_ArchiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_archive(inputs)
	return en_admin_registration_archive(inputs)
});